export { CipalLogo } from './cipal-logo';
